import { useEffect, useRef } from 'react';
import { getHookEventElement } from '../utils/internal/getHookEventElement';
import { useEvent } from './useEvent';
/**
 * Hook for element resize detection
 * @see https://developer.mozilla.org/docs/Web/API/ResizeObserver
 */
export function useOnElementResize(ref, effectProp, settings) {
    var _a;
    var isDisabled = settings === null || settings === void 0 ? void 0 : settings.isDisabled;
    var delay = (_a = settings === null || settings === void 0 ? void 0 : settings.delay) !== null && _a !== void 0 ? _a : 10;
    var effect = useEvent(effectProp);
    var timeoutRef = useRef(null);
    useEffect(function () {
        var element = getHookEventElement(ref);
        if (!element || isDisabled) {
            return undefined;
        }
        var destructor;
        var resizeObserver = new ResizeObserver(function () {
            destructor === null || destructor === void 0 ? void 0 : destructor();
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(function () {
                destructor = effect();
            }, delay);
        });
        resizeObserver.observe(element);
        return function () {
            resizeObserver.disconnect();
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            destructor === null || destructor === void 0 ? void 0 : destructor();
        };
    }, [delay, effect, isDisabled, ref]);
}
//# sourceMappingURL=useOnElementResize.js.map